// extracted by mini-css-extract-plugin
export var cartContainer = "_n7-4";
export var gray = "_n7-1";
export var itemContainer = "_n7-2";
export var itemDetails = "_n7-3";
export var strong = "_n7-0";